define(["require", "exports", "vue", "../../html-templates/dropzone-file-upload-component-vue-template.html", "../../html-templates/dropzone-preview-template.html", "vue2-dropzone", "../Controllers/FileUploadController"], function (require, exports, vue_1, template, previewTemplate, vue2Dropzone, FileUploadController_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var CustomThumbnailComponent = (function () {
        function CustomThumbnailComponent() {
            var base = this;
            vue_1.default.component('vue-dropzone', vue2Dropzone);
            vue_1.default.component('custom-thumbnail', {
                template: template,
                props: {
                    value: {
                        type: Object,
                        default: function () {
                            return {
                                model: null
                            };
                        }
                    },
                    index: {
                        type: Number,
                        default: function () {
                            return null;
                        }
                    }
                },
                watch: {
                    value: {
                        handler: function () {
                            console.log("value handler", this.model, this.value);
                            this.model = this.value;
                            this.LoadFileFromModel();
                        },
                        deep: true
                    }
                },
                data: function () {
                    return {
                        model: this.value,
                        dropzoneOptions: {
                            url: 'https://httpbin.org/post',
                            thumbnailWidth: 160,
                            thumbnailHeight: null,
                            thumbnailMethod: 'contain',
                            autoProcessQueue: false,
                            previewTemplate: previewTemplate,
                            maxFiles: 1,
                            acceptedFiles: 'image/gif, image/jpeg, image/png'
                        }
                    };
                },
                methods: {
                    update: function (event) {
                        this.$emit('input', this.model);
                    },
                    LoadFileFromModel: function () {
                        if (this.model == null)
                            return;
                        var file = { name: this.model.OriginalFilename, size: this.model.FileSize, type: this.model.ContentType, serverID: this.model.Id, accepted: true };
                        for (var _i = 0, _a = this.$refs.dropZone.getAcceptedFiles(); _i < _a.length; _i++) {
                            var item = _a[_i];
                            if ((item.serverID === file.serverID) || (item.name == file.name && item.size == file.size))
                                return;
                        }
                        this.$refs.dropZone.manuallyAddFile(file, this.model.Url);
                    },
                    MaxFilesExceeded: function (file) {
                        this.$refs.dropZone.removeFile(file);
                        console.log("MaxFilesExceeded");
                    },
                    FilesAdded: function (files) {
                        var _this = this;
                        console.log("file added");
                        var iMax = 10;
                        var interval = window.setInterval(function () {
                            var files = _this.$refs.dropZone.getQueuedFiles();
                            if (files.length > 0) {
                                window.clearInterval(interval);
                                iMax--;
                                var fileUploadController = new FileUploadController_1.FileUploadController(window["selectedTenant"], {
                                    Type: "asset",
                                    createApiUrl: "../api/v1/contents",
                                    minioClientGetPresignedUrl: "../api/v1/contents/getpresignedurl/?CustomThumbnail=true",
                                    autoCreateProgressbars: false,
                                    minioClientDebug: true,
                                    autoCreateAssetAfterFileUploaded: false
                                });
                                fileUploadController.minioClient.AddEventListener("GetPresignedUrlFinished", function (sender, data) { return _this.OnGetPresendUrlFinishedHandler(sender, data); });
                                fileUploadController.minioClient.AddEventListener("FileUploaded", function (sender, data) {
                                    _this.$emit('uploadcompleted', _this);
                                });
                                fileUploadController.minioClient.AddEventListener("FileUploadFailed", function (sender, data) {
                                    _this.$refs.dropZone.removeFile(_this.$refs.dropZone.getQueuedFiles()[0]);
                                    _this.$emit('uploadfailed', _this);
                                });
                                fileUploadController.files = files;
                                fileUploadController.Upload();
                                var fileUploadCollection = fileUploadController.minioClient.GetFileUploads();
                                for (var index in fileUploadCollection) {
                                    fileUploadCollection[index].AddEventListener("FileProgress", function (sender, data) {
                                        var progress = Math.floor(data.progress * 100);
                                        _this.$refs.dropZone.dropzone._callbacks.uploadprogress[0](files[0], progress, 0);
                                        if (progress == 100) {
                                            _this.$refs.dropZone.$el.classList.add("upload-finished");
                                        }
                                    });
                                }
                                _this.$emit('uploadstarted', _this);
                            }
                            if (iMax <= 0)
                                window.clearInterval(interval);
                        }, 200);
                    },
                    OnGetPresendUrlFinishedHandler: function (sender, data) {
                        if (this.$refs.dropZone.getQueuedFiles().length < 1)
                            return;
                        this.model = (data.Asset).Items[0];
                        this.update();
                        var quedFiles = this.$refs.dropZone.getQueuedFiles();
                        for (var i in quedFiles)
                            if (quedFiles[i].name == data.fileName)
                                quedFiles[i].status = "complete";
                    },
                    FileRemoved: function (file, error, xhr) {
                        if (this.$refs.dropZone.getAcceptedFiles().length > 0)
                            return;
                        this.$refs.dropZone.$el.classList.remove("upload-finished");
                        this.model = null;
                        this.update();
                        this.$emit('uploadaborted', this);
                    }
                }
            });
        }
        return CustomThumbnailComponent;
    }());
    exports.CustomThumbnailComponent = CustomThumbnailComponent;
});
//# sourceMappingURL=CustomThumbnailComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Components/CustomThumbnailComponent.js
// module id = 393
// module chunks = 0